import { Helmet } from "react-helmet-async";

/**
 * Reusable per-page SEO head tags including JSON-LD.
 * `image` should be an absolute URL when possible.
 */
export default function SEO({
  title,
  description,
  path = "",
  image,
  type = "website",
  jsonLd,
  noIndex = false,
}) {
  const canonical = `https://bootybreeze.com${path}`;
  const ogImage = image || "https://bootybreeze.com/og-image.png";
  return (
    <Helmet>
      <title>{title ? `${title} — Booty Breeze` : "Booty Breeze — Adult Novelty Air Fresheners"}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title || "Booty Breeze"} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || "Booty Breeze"} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
